module.exports = __webpack_public_path__ + "static/duaa-6b8eaad938ae243074d8c476f9221c69.jpg";